import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { IGetTime } from '../../domain/use-cases/i-get-time'
import type { IGetTimeClient } from '../data-sources/i-get-time-client'

export class GetTimeRepository implements IGetTime {
  constructor(private readonly dataSource: IGetTimeClient) {}

  async getTime(): Promise<Date> {
    const result = await this.dataSource.getTime()

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result?.message!)
    }

    return result.data
  }
}
